// ============================================================
//  src/runtime-flags.js — Lee systemConfig/runtime una vez por sesión
//  Defaults enabled=true si el doc no existe o falla la lectura.
// ============================================================

import { db }            from './firebase.js';
import { getDoc, doc }   from 'firebase/firestore';

const _DEFAULTS = {
    emergencyMode:       false,
    uploadsEnabled:      true,
    emailsEnabled:       true,
    managedDriveEnabled: true,
    publicEmbedsEnabled: true,
};

let _cache = null;

export async function getRuntimeFlags() {
    if (_cache) return _cache;
    try {
        const snap = await getDoc(doc(db, 'systemConfig', 'runtime'));
        if (!snap.exists()) {
            _cache = { ..._DEFAULTS };
            return _cache;
        }
        const d = snap.data();
        _cache = {
            emergencyMode:       d.emergencyMode       ?? false,
            uploadsEnabled:      d.uploadsEnabled      ?? true,
            emailsEnabled:       d.emailsEnabled       ?? true,
            managedDriveEnabled: d.managedDriveEnabled ?? true,
            publicEmbedsEnabled: d.publicEmbedsEnabled ?? true,
        };
        return _cache;
    } catch {
        return { ..._DEFAULTS };
    }
}
